import { FaCalendarPlus } from "react-icons/fa6";
import TableComponent from "../TableComponent";

const UpCommingPM = ({ upComingPm }) => {
  const header = [
    { value: "service_id", label: "Service ID" },
    { value: "vehicle.registration_number", label: "Vehicle" },
    { value: "services_type", label: "Service Type" },
    { value: "priority", label: "Priority" },
    { value: "status", label: "Status" },
    { value: "complete_total", label: "Total" },
  ];

  return (
    <div className="card_container">
      <TableComponent
        heading="Upcoming PMs"
        icon={<FaCalendarPlus size={20} className="me-2" />}
        columns={header}
        data={upComingPm || []}
        currentPage={1}
      />
    </div>
  );
};

export default UpCommingPM;
